<app-viewer-layout>

    <!-- VIEWERS -->
    <div class="relative" [class]="{'pointer-events-none': disabledByLogin, 'h-[650px]': importMode, 'h-dvh': !importMode}">
        
        <!-- MAP VIEWER -->
        <app-map-viewer/>
        
        <!-- 3D VIEWER -->
        <app-viewer3d/>

        @if(mode === ViewerMode.View) {
            <app-cookies></app-cookies>
        }


    </div>
    
</app-viewer-layout>